import * as React from "react";
import "./followedUser.css";
import "../../style/fonts.css";
import translate from "../../translations/i18n";
import Avatar from "../profileTop/avatar";
import moment from "moment";
import { Link } from "react-router-dom";
import { calculateSmokeless } from "../../functions/calculateSmokeless";

export interface Props {
  user: any;
}

class FollowedUser extends React.Component<Props, any> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    if (this.props.user) {
      const linkToProfile = "/profile/" + this.props.user.uid;
      const daysString = calculateSmokeless(this.props.user.start_date);
      return (
        <div className="FOLLOWED_USER_CONT">
          <Link to={linkToProfile}>
            <div className="FOLLOWED_USER_CONT_CARD">
              <div className="AVATAR_USER_CARD">
                <Avatar
                  avatar={this.props.user.avatar}
                  width={36}
                  height={48}
                />
              </div>
              <div className="FOLLOWED_USER_INFO">
                <div className="FOLLOWED_USER_DAYS">
                  <div className="SMALL_TEXT1">{daysString}</div>
                </div>
                <div className="FOLLOWED_USER_USERNAME">
                  <div className="TITLE_4">{this.props.user.name}</div>
                </div>
              </div>
            </div>
          </Link>
        </div>
      );
    } else return null;
  }
}

export default FollowedUser;



// WEBPACK FOOTER //
// ./src/components/followList/followedUser.tsx